<template>
    <center>
      <div class="card card-body agatrs-card-style">
        <Header 
          pageTitle="Country Summary">
        </Header>
        <div class="row justify-content-center">
          <div class="col-md-12 subtitle">
            {{ subtitle }}
          </div>
        </div>
        <br/>
        <div class="row justify-content-center">
          <div class="col-md-12 subtitle2">
            {{ subtitle2 }}
          </div>
        </div>
        <br/>
        <br/>
        <div class="row justify-content-center">
          <div class="col-md-1 align-left">
            <label>Country:</label>
          </div>
          <div class="col-md-3">
            <treeselect v-model="countryId" 
              class="select-primary" 
              name="organization" 
              :value-consists-of="'LEAF_PRIORITY'" 
              :multiple="true" 
              :openOnClick="true" 
              :limit="10" 
              :clearable="true" 
              :searchable="true" 
              search-nested :options="[ {id: 0, label: 'All', children:countrySummaryList[0]}]" 
            />
            <template slot="option" slot-scope="option">
              <span class="flag-icon flag-icon-squared" :class="['flag-icon-' + option.twoCharacterCode]"></span>
              <span class="flag-text">{{ option.label }}</span>
            </template>
          </div>  
          <div class="col-md-1 align-left">
            <label>Fiscal Year:</label>
          </div>
          <div class="col-md-3">
            <base-input>
             
              <treeselect v-validate="'required'" v-model="year" name="FiscalYear" value="Name" :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10" :clearable="true" :searchable="true" :options="[ {id: 0, label: 'All', children:fiscalYears}]" placeholder="Select" />
            </base-input>
          </div>
        </div>
        <br />
        <div class="row justify-content-center">
          <div class="col-md-2 col-sm-12">
            <base-button
              class="btn btn-danger"
              @click="initializeAllData()"
              v-b-popover.hover.top="'Reset all fields!'"
            >
              <i class="tim-icons icon-alert-circle-exc"></i> Clear
            </base-button>
          </div>
  
          <div class="col-md-2 col-sm-12">
            <!-- justify-content-md-center justify-content-end -->
            <base-button
              @click="getData()"
              type="primary"
              v-b-popover.hover.bottom="'Generate Report!'"
            >
              <i class="tim-icons icon-atom"></i> Generate
            </base-button>
          </div>
          <div></div>
        </div>
      </div>
  
      <br />
  
      <!--  <div class="card card-body agatrs-card-style" v-if="aors?.length <= 0">
        <div class="card-container">
          <div class="title">
            <h4>No Results</h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-12">
            <br />
            <div style="padding: 20px 40px">
              No data was found for the selected criteria
            </div>
          </div>
        </div>
      </div>-->
  
      <div class="card card-body agatrs-card-style" v-if="html !== ''">
        <div class="card-container" >
          <div class="print" style="margin-bottom: 5px">
            <base-button @click="print" class="btn-dark">PRINT</base-button>
          </div>
        </div>
          <div class="row justify-content-center">
            <div class="col-md-12">
              <br />
              <div style="padding: 20px 40px">
                <div id="report" v-html="html"></div>
              </div>
            </div>
          </div>
      </div>
    </center>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import axios from "@/axios";
  import Header from "@/components/App/Header.vue";
  import Utility from "@/mixins/utility/utility";
  import Util from "@/util/util";
  import Treeselect from "@riophae/vue-treeselect";

  
  export default {
    name: "CreditReports",
    mixins: [Utility],
    components: {
      Header,
      Treeselect,
    },
    data() {
      return {
        aors: [],
        countryId: undefined,
        year: undefined,
        html: "",
        selectedBuyOrSell: undefined,
        selectedAorId: undefined,
        subtitle: "The country summary describes the total USD by Class of Supply for each Country and Fiscal Year. You can filter the report by a single country, multiple countries, or COCOM.",
        subtitle2: " The report breaks down total dollar amount by Buy/Sell and Order Status. Once the report opens, double click on dollar amounts for additional data."
      };
    },
    async mounted() {
      this.$loaderApp.addRequest();
      await this.getAllCountries();
      await this.getFiscalYears();
      await this.getCountrySummaryList();
      await this.getAors();
      this.selectedBuyOrSell = this.$route.meta.buyOrSell;
      this.$loaderApp.completeRequest();
    },
    computed: {
      ...mapGetters({
        countries: "countries/allCountries",
        fiscalYears: "fiscalYears/fiscalYears",
        countrySummaryList: "orderReport/countrySummaryList",
        jointStaffOrganizations: "orderReport/jointStaffOrganizations",

      }),
      isCountriesDisabled() {
        return this.selectedAorId > 0 ? true : false;
      },
    },
    watch: {
       selectedAorId(value) {
       let result = this.selectedAorId > 0 ? true : false;
  
       if(!result) return;
       
       this.countryId = undefined;
      },
    },
    methods: {
      ...mapActions({
        getAllCountries: "countries/getAllCountries",
        getFiscalYears: "fiscalYears/getFiscalYears",
        getCountrySummaryList: "orderReport/getCountrySummaryList",
        getJointStaffOrganizations: "orderReport/getJointStaffOrganizations",
      }),
      initializeAllData() {
        Object.assign(this.$data, this.$options.data());
      },
      getData() {
        if(this.countryId && this.year){
        this.$loaderApp.addRequest();
        this.$validator.validateAll().then((result) => {
          if (result) {
            var ctx = this;
            axios({
              url: "/api/acsareports/countrysummary/filters",
              method: "POST",
              data: {
                countryIds: ctx.countryId,
                fys: ctx.year,
              },
              responseType: "blob", 
              config: { showToast: false },
            }).then((response) => {           
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(
              new Blob([response.data]));  

              link.setAttribute('download', 'Country Summary.xlsx');
              document.body.appendChild(link);     
              ctx.$loaderApp.completeRequest();  
              link.click();
            }).catch((error) => {
              ctx.$toast.error(error);
              ctx.$loaderApp.completeRequest();
            });
          }
        });
        }else{
          if(!this.year){
            this.$toast.error('Error:  Plesse select any one Fiscal year');
          }else if(!this.countryId) {
            this.$toast.error('Error: Plesse select any one country');
          }
        }
      },
      print() { 
        this.$validator.validateAll().then((result) => {
          if (result) {
            let ctx = this;
            axios({
              url: "/api/fmrs/creditreport/pdf",
              method: "POST",
              data: {
               countryId: ctx.countryId,
                fiscalYear: ctx.year,
                buyOrSell: ctx.selectedBuyOrSell,
                AreaOfResponsibilityId: ctx.selectedAorId,
              },
              config: { showToast: false },
              responseType: "blob", // important
            }).then((response) => { Util.fileDownload(response.data, "Credit Report.pdf");});
          }
        });
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      async getAors() {
          const response =  await this.axios.get("/api/aors");
          this.aors = response.data;
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .card-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 0px;
    max-width: 100%;
    min-width: 400px;
    .print {
      margin: auto;
      margin-left: 0px;
      padding: 0px;
      flex-grow: 1;
      text-align: left;
    }
    .title {
      margin: auto;
      margin-left: 0px;
      padding: 0px;
      text-align: center;
      flex-grow: 1;
      text-align: left;
      align-items: center;
      .title > h2 {
        text-align: left !important;
      }
    }
    .disabled {
      pointer-events: none;
      color: #bfcbd9;
      cursor: not-allowed;
      background-image: none;
      background-color: #eef1f6;
      border-color: #d1dbe5;
    }
  }
  .subtitle {
    padding-left: 15% !important;
    padding-right: 15% !important;
    padding-bottom: 20px !important;
  }
  .subtitle2 {
    padding-bottom: 20px !important;
  }
  </style>
  